export default __webpack_public_path__ + "static/Montserrat-SemiBold-d5e0cc788cba9ced1fb9251328ff64ec.ttf";